import { Button } from "primereact/button";
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { selectInspectionIsDisabled } from "../../store/selectors/inspectionSelectors";
import { setShowDeleteSelected } from "../../store/slices/positiveItemSlice";
import { selectPositiveItemsToDelete } from "../../store/selectors/positiveItemSelectors";

export const PositiveItemsDeleteButton = () => {
    const dispatch = useAppDispatch();

    const positiveItems = useAppSelector(selectPositiveItemsToDelete);
    const inspectionDisabled = useAppSelector(selectInspectionIsDisabled);

    const onDelete = useCallback(() => {
        dispatch(setShowDeleteSelected(true));
    }, [positiveItems]);

    return (
        <Button label="Delete Selected" severity="danger" className="ml-3" onClick={onDelete} disabled={inspectionDisabled || positiveItems.length === 0} data-cy="delete-selected-button"/>
    );
}